import { render, staticRenderFns } from "./PageTopSection.vue?vue&type=template&id=aa02b8d8&scoped=true"
import script from "./PageTopSection.vue?vue&type=script&lang=js"
export * from "./PageTopSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa02b8d8",
  null
  
)

export default component.exports